import { render, staticRenderFns } from "./CbsFields.vue?vue&type=template&id=671bd524&scoped=true"
import script from "./CbsFields.vue?vue&type=script&lang=js"
export * from "./CbsFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671bd524",
  null
  
)

export default component.exports